/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setpoint_Start_Frost_FreeInputs */



/**
* | output |
* | --- |
* | "External temperature for boiler start" |
*
* @param {Setpoint_Start_Frost_FreeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const setpoint_start_frost_free = /** @type {((inputs?: Setpoint_Start_Frost_FreeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setpoint_Start_Frost_FreeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("External temperature for boiler start")
	return /** @type {LocalizedString} */ ("Température ext. d'allumage des chaudières")
});